export default __webpack_public_path__ + "img/bmaTmUql.9a3ff265.svg";